import { Skeleton, SxProps, Theme } from '@mui/material';

export const EspotSkeleton: React.FC<{
	emsName?: string;
	sx?: SxProps<Theme>;
}> = ({ emsName, sx }) => {
	if (!emsName) return null;

	if (emsName.endsWith('_Logo'))
		return <Skeleton variant="rectangular" width={60} height={60} sx={sx} />;

	switch (emsName) {
		case 'MainHeader_SuperiorSection':
			return <Skeleton variant="rectangular" width="100%" height={22.8} sx={sx} />;
		case 'MainHeader_InferiorSection':
			return <Skeleton variant="rectangular" width="100%" height={5} sx={sx} />;
		default:
			return null;
	}
};
